export default "__VITE_ASSET__DsBjj0SK__"